const getPublicEnv = (key: string): string =>
  typeof window !== 'undefined' && typeof window.getPublicEnv !== 'undefined' ? window.getPublicEnv(key) : '';

export default getPublicEnv;
